document.addEventListener('DOMContentLoaded', () => {

  // ─── 1. REDIRECT RICERCA CON SKU ─────────────────────────────────────────
  const form = document.querySelector('predictive-search-element form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const q = encodeURIComponent(form.querySelector('.search--textbox').value.trim());
      window.location.href = `${Shopify.routes.search}?type=product&q=${q}&options[fields]=title,product_type,variants.sku,vendor`;
    }, true);
  }

  // ─── 2. PREDICTIVE SEARCH CON SKU ────────────────────────────────────────
  const patchPredictiveSearch = (el) => {
    el.getSearchResults = async function(t) {
      this.abort_controller && this.abort_controller.abort();
      const e = t.trim();

      if (this.cached_results[e]) {
        this.results.innerHTML = this.cached_results[e];
        return;
      }

      this.abort_controller = new AbortController();
      this.toggleLoading(true);

      try {
        const i = encodeURIComponent(t);
        const s = await fetch(
          `${Shopify.routes.predictive_search}?q=${i}&section_id=predictive-search&resources[type]=product&resources[options][fields]=title,product_type,variants.sku,vendor`,
          { signal: this.abort_controller.signal }
        );
        if (!s.ok) throw new Error(s.status);
        const r = (await s.text()).parse().innerHTML;
        this.cached_results[e] = r;
        this.results.innerHTML = r;
      } catch {}
    };
  };

  const el = document.querySelector('predictive-search-element');
  if (el) {
    patchPredictiveSearch(el);
  } else {
    const observer = new MutationObserver(() => {
      const el = document.querySelector('predictive-search-element');
      if (el) {
        patchPredictiveSearch(el);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

});